import { Component, Input, OnInit } from '@angular/core';
import ProjectHelper from 'src/app/helpers/project-helper';
import Company from 'src/app/model/company/company';
import { Adjustment } from 'src/app/model/project/adjustment';
import { Project } from 'src/app/model/project/project';
import { ImmoBillingDetailSubProject } from 'src/app/pages/immo-ip/overview/billing-detail/model/immo-billing-detail-sub-project';

@Component({
  selector: 'client-adjustment-invoice-info',
  templateUrl: './client-adjustment-invoice-info.component.html',
  styleUrls: ['./client-adjustment-invoice-info.component.scss']
})
// for now, the only intended usage of this component is in the ImmoBillingDetailComponent modal
export class ClientAdjustmentInvoiceInfoComponent implements OnInit {
  @Input()
  adjustment: Adjustment;

  @Input()
  baseProject: ImmoBillingDetailSubProject;

  @Input()
  project: Project;

  involvedCompanies: Company[];

  ngOnInit(): void {
    this.involvedCompanies = ProjectHelper.getInvolvedCompanies(this.project);
  }
}
